<div>
  <div id="container" *ngIf="passValues.length!=0">
    <div id="candidate-body" *ngFor="let items of passValues; let lastItem = last; let i = index;">
      <ng-container *ngIf="viewSize === 'large'">
        <div class="row" class="hpanel">
          <div class="panel-body border-radius-top-left-right-6 pad-cus hover-border" [ngClass]="{
            'disabled': !items.availability || (items?.status !='ACTIVE' && items?.createdBy != userId),
            'pad-10': viewSize == 'large',
            'featured-background': items.isFeatured==true,
            'Business_background': items.transferJob
           }">

            <div class="col-md-3"  [ngClass]="{'business-jobs': CheckboxforBusinessJobs}"  >
              <div class="col-sm-1"  *ngIf="CheckboxforBusinessJobs">
                <input id="candidate_business_checkbox" type="checkbox" (click)="BusinessJobChecked($event.target.checked , items )"   [(ngModel)]="items.transferJob" aria-label="Select" />
              </div>

              <div class="media social-profile social-profileCustom clearfix  col-sm-11">
                <a class="pull-left  card-profImg">
                  <span class="label label-success ui-align-role" *ngIf="items?.user?.userType == 'FREELANCE_RECRUITER'"
                    title="Freelance Recruiter">FR </span>
                  <span class="label label-success ui-align-role" *ngIf="items?.user?.userType == 'student'"
                    title="Student">ST </span>
                  <span class="label label-success ui-align-role" *ngIf="items?.user?.userType == 'JOB_SEEKER'"
                    title="Job Seeker">JS </span>
                  <span class="label label-success ui-align-role"
                    *ngIf=" items?.user?.userType!= 'FREELANCE_RECRUITER' && items?.user?.userType!= 'student' && items?.user?.userType!= 'JOB_SEEKER' &&items?.user?.workExperience !=null&& items?.user?.workExperience[0]?.clientType == 'Vendor'"
                    title="Vendor">V</span>
                  <span class="label label-success ui-align-role"
                    *ngIf="items?.user?.userType!= 'FREELANCE_RECRUITER' && items?.user?.userType!= 'student' && items?.user?.userType!= 'JOB_SEEKER'&&items?.user?.workExperience !=null&& items?.user?.workExperience[0]?.clientType == GigsumoConstant.DIRECT_HIRE"
                    title="Direct Hire">DH</span>
                  <span class="label label-success ui-align-role"
                    *ngIf="items?.user?.userType!= 'FREELANCE_RECRUITER' && items?.user?.userType!= 'student' && items?.user?.userType!= 'JOB_SEEKER' &&items?.user?.workExperience!=null && items?.user?.workExperience[0]?.clientType == 'Systems Integrator'"
                    title="Systems Integrator">SI</span>
                  <span class="label label-success ui-align-role"
                    *ngIf="items?.user?.userType!= 'FREELANCE_RECRUITER' && items?.user?.userType!= 'student' && items?.user?.userType!= 'JOB_SEEKER' &&items?.user?.workExperience!=null && items?.user?.workExperience[0]?.clientType == 'Prime Vendor'"
                    title="Prime Vendor">PV </span>
                  <span class="label label-success ui-align-role"
                    *ngIf="items?.user?.userType!= 'FREELANCE_RECRUITER' && items?.user?.userType!= 'student' && items?.user?.userType!= 'JOB_SEEKER' &&items?.user?.workExperience!=null && items?.user?.workExperience[0]?.clientType == 'Staffing Agency'"
                    title="Staffing Agency">SA
                  </span>
                  <span class="label label-success ui-align-role"
                    *ngIf="items?.user?.userType!= 'FREELANCE_RECRUITER' && items?.user?.userType!= 'student' && items?.user?.userType!= 'JOB_SEEKER' &&items?.user?.workExperience!=null && items?.user?.workExperience[0]?.clientType == 'Direct Client'"
                    title="Direct Client">DC </span>
                  <span class="label label-success ui-align-role"
                    *ngIf="items?.user?.userType!= 'FREELANCE_RECRUITER' && items?.user?.userType!= 'student' && items?.user?.userType!= 'JOB_SEEKER' &&items?.user?.workExperience!=null && items?.user?.workExperience[0]?.clientType == 'Supplier'"
                    title="Supplier">SP </span>
                   <img *ngIf="items?.user?.photo" [src]="getPhotoUrl(items?.user?.photo)"
                    alt="profile-picture">

                  <!-- Initials fallback when no photo -->
                  <div *ngIf="!items?.user?.photo" class="circles" [style.background-color]="getColor(items?.user?.fullname)">
                    <div class="circle-text" [style.color]="getFullNameTextColor(items?.user?.fullname)">{{ getInitials(items?.user?.fullname) }}</div>
                  </div>

                  <!-- User Role -->
                </a>
                <div id="candidate_media_body" class="media-body" (click)="$event.stopPropagation();">
                  <div id="candidate_user_card_list" class="flex viewuserCardList" (click)="$event.stopPropagation();">

                    <div style="margin-right:14px;" class="custom-checkbox "
                      *ngIf="items.currentStatus == undefined && items.inviteStatus == undefined  && filtersApplied"
                      title="Select Candidate">
                      <input id="candidate_select_checkbox" class="check-btn-ui check-ui" (change)="selectCheckbox($event,items?.candidateId, i)"
                        type="checkbox" value="{{items?.user?.userId}}" [(ngModel)]="items.isSelected"
                        name="list_name" />
                    </div>
                    <h5 *ngIf="items?.user?.fullname!=null" class="me-5">{{ (items?.user?.fullname?.length > 10) ?
                      (items?.user?.fullname | slice:0:15) + "..": (items?.user?.fullname)}}</h5>
                  </div>
                  <h6 *ngIf="items.postedBehalfOf != null" title="{{items.postedBehalfOf}}">
                    {{items.postedBehalfOf}}</h6>

                  <small class="text-muted">  {{ items?.createdOn | timezoneDate:'MM/dd/yyyy' }}
                  </small>



                </div>
              </div>

            </div>
            <div class="col-md-9 cardListItm ">

              <div class=" flex pull-right actItemList">
                <div id="candidate_open_profile_button" (click)="open(items)">
                  <div
                    *ngIf="filtersApplied&&items.currentStatus!=null||filtersApplied&&items.inviteStatus!=null; else statusShow"
                     class="br-pd-1"
                    [ngClass]="{
                      'rejected-label':items.currentStatus === 'REJECTED',
                      'onboarded-label': items.currentStatus === 'ONBOARDED',
                      'interview-scheduled-label': items.currentStatus === 'INTERVIEW SCHEDULED',
                      'shortlisted-label': items.currentStatus === 'SHORTLISTED',
                      'preonboarded-label': items.currentStatus === 'PREONBOARDED',
                      'offer-withdrawn-label': items.currentStatus === 'OFFER WITHDRAWN',
                      'accepted-label': items.currentStatus === 'ACCEPTED',
                      'applied-label': items.currentStatus === 'APPLIED',
                      'interview-rejected-label': items.currentStatus === 'INTERVIEW REJECTED',
                      'offer-declined-label': items.currentStatus === 'OFFER DECLINED',
                      'initiated-label': items.inviteStatus === 'INITIATED',
                      'interest-shown-label': items.inviteStatus === 'INTETEREST_SHOWN',
                      'candidate-backout-label': items.currentStatus === 'CANDIDATE BACKOUT',
                      'invite-accepted-label': items.inviteStatus === 'ACCEPTED',
                      'invite-rejected-label': items.inviteStatus === 'REJECTED',
                      'invite-initiated-label': items.inviteStatus === 'INITIATED',
                      'offered-label':items.currentStatus === 'OFFERED'
                    }">
                    <ng-container *ngIf="items.inviteStatus === 'INITIATED'"> Invited </ng-container>
                    <ng-container *ngIf="items.inviteStatus === 'INTETEREST_SHOWN'"> Invited </ng-container>
                    <ng-container *ngIf="items.inviteStatus === 'REJECTED'"> Rejected </ng-container>
                    <ng-container *ngIf="items.currentStatus != 'INITIATED'">
                      {{items.currentStatus|titlecase}}</ng-container>
                  </div>
                  <ng-template #statusShow>
                    <div *ngIf="filtersApplied" [style.background-color]="getButtonColor(items)" style="color:white"
                      class="active-label br-pd-1">
                      <span *ngIf="filtersApplied && items.currentStatus==null">Available</span>
                    </div>
                    <div *ngIf="items.status=='DRAFTED'"
                    class="draft-label br-pd-1">Draft</div>
                  </ng-template>
                </div>

                <div id="jb_dpDown" [ngClass]="{'disabled':items.status=='BLOCKED'}" class="btn-group" dropdown
                  *ngIf="items.createdBy==userId ">
                  <div
                    *ngIf="items.status !='DRAFTED' &&filtersApplied==false"
                    data-toggle="dropdown" dropdownToggle class="btn status-action-btn fRCard dropdown-toggle"
                    aria-expanded="true"
                    class="br-pd-1"
                    [ngClass]="{'active-label': (items.status === 'ACTIVE' && items.createdBy==userId),
                    'active-non-owner-label': (items.status === 'ACTIVE' && items.createdBy!=userId),
                                                          'inactive-label':(items.status === 'INACTIVE'),
                                                          'onhold-label':(items.status === 'ON HOLD'),
                                                          'closed-label':(items.status === 'CLOSED'),
                                                          'filled-label':(items.status === 'FILLED'),

                                                          }">
                    <ng-container *ngIf="items.status=='ACTIVE'"> Available</ng-container>
                    <ng-container *ngIf="items.status=='INACTIVE'">Unavailable</ng-container>
                    <ng-container *ngIf="items.status=='AWAITING HOST'">Awaiting Post</ng-container>
                    <ng-container *ngIf="items.status=='BLOCKED'">Available</ng-container>
                    <ng-icon name="tablerChevronDown" style="margin-left:9px;float:right; margin-top: 6px;"
                      aria-hidden="true"></ng-icon>
                  </div>

                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                     style="right:-9px; left: auto; margin-top: 3px; z-index: 2;"  aria-labelledby="button-animated">
                    <li role="menuitem" *ngIf="items.status!='ACTIVE'&& items.status !='DRAFTED' "
                      (click)="candidateStatus('ACTIVE',items)" id="ACTIVE">
                      <a id="ACTIVE"> <ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon>
                        Available
                      </a>
                    </li>
                    <li role="menuitem"
                      *ngIf="items.status!='INACTIVE' && items.status !='DRAFTED'&& items.status !='AWAITING HOST'"
                      (click)="candidateStatus('INACTIVE',items)" id="INACTIVE">
                      <a id="INACTIVE"> <ng-icon name="tablerCircle" class="fs-status-icon t-filled" aria-hidden="true"></ng-icon>
                        Unavailable </a>
                    </li>
                    <!-- <li class="disabled" role="menuitem" id="Deactivated">
                      <a id="Deactivated"> <ng-icon name="tablerCircle" class="fs-status-icon t-close" aria-hidden="true"></ng-icon>
                        Deactivated </a>
                    </li> -->
                  </ul>
                </div>

                <div id="jb_dpDown" class="btn-group" dropdown *ngIf="items.createdBy==userId ">
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                    style="right: -124px; left: auto; margin-top: -26px; z-index: 2;" aria-labelledby="button-animated">
                    <li role="menuitem" *ngIf="items.status!='ACTIVE'&& items.status !='DRAFTED' "
                      (click)="candidateStatus('ACTIVE',items)" id="ACTIVE">
                      <a id="ACTIVE"> <ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon>
                        Available
                      </a>
                    </li>
                    <li class="disabled" role="menuitem" *ngIf="items.status!='INACTIVE' && items.status !='DRAFTED'"
                      (click)="candidateStatus('INACTIVE',items)" id="INACTIVE">
                      <a id="INACTIVE"> <ng-icon name="tablerCircle" class="fs-status-icon t-filled" aria-hidden="true"></ng-icon>
                        Unavailable </a>
                    </li>
                  </ul>
                </div>

                <div id="jb_dpDown" class="btn-group" dropdown *ngIf="items.createdBy!=userId  ">
                  <div
                    *ngIf="items.status !='DRAFTED'&& items.status !='INACTIVE_DUE_TO_LOW_CREDITS'&&filtersApplied==false||items.status=='ACTIVE'"
                    data-toggle="dropdown" dropdownToggle
                    aria-expanded="true"
                    class="br-pd-1 dropdown-toggle"
                    [ngClass]="{'active-label': (items.status === 'ACTIVE' && items.createdBy==userId),
                    'active-non-owner-label': (items.status === 'ACTIVE' && items.createdBy!=userId),
                                                          'inactive-label':(items.status === 'INACTIVE'),
                                                          'onhold-label':(items.status === 'ON HOLD'),
                                                          'closed-label':(items.status === 'CLOSED'),
                                                          'filled-label':(items.status === 'FILLED'),
                                                           }">
                    <ng-container *ngIf="items.status=='ACTIVE'"> Available</ng-container>
                  </div>
                </div>

                <div [ngClass]="{'disabled':items.status=='BLOCKED'}" class="btn-group "
                  *ngIf="items.createdBy==userId && !filtersApplied " dropdown>
                  <a id="button-animated" dropdownToggle>
                    <img src="assets/icon/action.png" class="img-width-dot-icon" />
                  </a>
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                    style="right: 0; left: auto; z-index: 2;" aria-labelledby="button-animated">
                    <!-- <li role="menuitem">
                      <a id="candidate_view_button2" (click)="open(items)">
                        <ng-icon name="tablerEye" aria-hidden="true"></ng-icon> View
                      </a>
                    </li> -->
                    <li role="menuitem" *ngIf=" items.createdBy==userId">
                      <a id="candidate_edit_button" (click)="edit(items)">
                        <ng-icon name="tablerEdit" aria-hidden="true"></ng-icon> Edit
                      </a>
                    </li>
                    <li id="candidate_upgrade_button" (click)="upgradeCandidate(items)" role="menuitem"
                      *ngIf="items.createdBy==userId  && items.status!='INACTIVE'  && items.status!='DRAFTED'  && items.isFeature=='null'    && userType !='JOB_SEEKER'  ||   !items.isFeatured  && items.status!='INACTIVE' && items.status!='DRAFTED'   &&items.createdBy==userId   && userType !='JOB_SEEKER' ">
                      <a>
                        <ng-icon name="tablerCircleArrowUp" aria-hidden="true"></ng-icon> Upgrade Candidate
                      </a>
                    </li>
                    <li id="candidate_downgrade_button" (click)="downgradeCandidate(items)" role="menuitem"
                      *ngIf="items.createdBy==userId  && items.status!='INACTIVE'  && items.status!='DRAFTED'  && items.isFeatured && userType !='JOB_SEEKER'  ||   items.isFeatured  && items.status!='INACTIVE' && items.status!='DRAFTED'  && items.createdBy==userId     && userType !='JOB_SEEKER' ">
                      <a>
                        <ng-icon name="tablerCircleArrowDown" aria-hidden="true"></ng-icon> Downgrade Candidate
                      </a>
                    </li>
                    <li id="candidate_republish_button" (click)="republishCandidate(items)" role="menuitem"
                      *ngIf="items.createdBy==userId && items.status=='ACTIVE'">
                      <a>
                        <ng-icon name="tablerRefresh" aria-hidden="true"></ng-icon> Republish
                      </a>
                    </li>
                    <li id="candidate_delete_button" (click)="deletecandidate(items.candidateId)" role="menuitem"
                      *ngIf="items.createdBy==userId  && items.status=='DRAFTED'">
                      <a>
                        <ng-icon name="tablerTrash" aria-hidden="true"></ng-icon> Discard
                      </a>
                    </li>
                  </ul>
                </div>

                <!-- Non-owner kebab. Report Candidate is the ONLY thing this menu
                     can ever contain - the Upgrade Candidate item below requires
                     createdBy==userId, which can never be true inside this
                     createdBy!=userId wrapper - so with reportEnabled off the button
                     would open an empty dropdown. Gated on the same flag so the whole
                     control disappears and comes back together. -->
                <div class="btn-group pull-right" *ngIf="reportEnabled && items.createdBy!=userId && !filtersApplied" dropdown>
                  <a id="button-animated" dropdownToggle>
                    <img src="assets/icon/action.png" class="img-width-dot-icon" />
                  </a>
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                    style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                    <li role="menuitem" class="report" *ngIf="reportEnabled"
                      style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                      <app-flag type="CANDIDATE" [id]="items.candidateId" [flagTo]="items.createdBy"
                        [flags]="['Report Candidate as fake.']">
                      </app-flag>
                    </li>
                    <!-- <li role="menuitem">
                      <a id="candidate_view_profile_button" (click)="open(items)">
                        View
                      </a>
                    </li> -->

                    <li id="candidate_upgrade_button2" (click)="upgradeCandidate(items)" role="menuitem"
                      *ngIf=" items.createdBy==userId && items.isFeature=='null'  &&  userType !='student' && userType !='JOB_SEEKER'  ||   !items.isFeatured && items.createdBy==userId &&  userType !='student' && userType !='JOB_SEEKER' ">
                      <a>
                        Upgrade Candidate
                      </a>
                    </li>
                  </ul>

                </div>
              </div>

              <span id="candidate_submitted_jobs_link" *ngIf="items?.submittedJobsCount>0" (click)="redirect_invite(items, 'jobsApplied')"
                class="candidate-submits">
                <b>{{items?.submittedJobsCount}} {{items?.submittedJobsCount > '1' ? 'Jobs' : 'Job'}}</b>
              </span>

              <div id="candidate_primary_card_button" class="primary-card-show" (click)="open(items)">
                <h6 id="candidate_name" class="text-wrapsfilter   " style="font-weight: bold; text-transform: capitalize;"
                  *ngIf="items?.firstName!=null" title="{{items.firstName + ' ' + items.lastName }}">
                  {{items.firstName + " " + items.lastName }} </h6>
                <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(items) as urgencyDays">
                  <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Hot</span>
                </div>
                <div class="btn-group jobProfileBtngp text-wrapsfilter">
                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="items?.primarySkills?.length==1">
                    <div *ngFor="let data of items?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-1-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>

                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="items?.primarySkills?.length==2">
                    <div *ngFor="let data of items?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-2-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>

                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="items?.primarySkills?.length==3">
                    <div *ngFor="let data of items?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-3-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="candidate_experience_button" (click)="open(items)" class="pointer" style="padding: 5px; margin-top: -4px; margin-bottom: 3px;">
                Experience :
                {{
                items.totalExperience }} Years</div>
              <div id="candidate_details_button" (click)="open(items)" style="display: flex; flex-direction: column; width: 100%;">
                <div class="row clientDetailList" title=" {{items.clientType}}, {{items.city}}, {{items.state}} ">
                  <div class="mb-5" title="{{items.clientName}}" *ngIf="items.showClientName">
                    <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
                    {{items.clientName | truncate:20}}
                  </div>
                  <div class="mb-5">
                    <ng-icon name="tablerMapPin" *ngIf="items.city || items.state"></ng-icon>
                    <span title="{{items.city}}"> {{items.city}} </span>
                    <span title="{{items.state}}" *ngIf="items.state">, {{items.state}}</span>
                  </div>
                  <div class="mb-5" [title]="'Pay Rate: ' +
                                    (items?.country === 'US' ? '$' : '') +
                                    items?.targetRateFrom + ' - ' + items?.targetRateTo + ' ' +
                                    getCurrency(items?.country) + ' / ' +
                                    getPayType(items?.payType)"
                    *ngIf="items?.targetRateFrom != undefined && items?.targetRateTo != undefined" class="job-pay">
                    Pay Rate:
                    <span>
                      {{items?.country === 'US' ? '$' : ''}}
                      {{items?.targetRateFrom}} - {{items?.targetRateTo}}
                    </span>
                    <span>{{getCurrency(items?.country)}} / {{getPayType(items?.payType)}}</span>

                  </div>
                  <div *ngIf="items.resumes?.length>0 && items.createdBy==userId "> <ng-icon name="tablerId"></ng-icon>
                    <span style="padding-left: 8px;">Attached</span> <span class="blue-color"
                      style="padding-left: 3px;">{{items?.resumes?.length}}</span>
                  </div>
                </div>
              </div>
              <hr class="line-tag">

              <div class="interactive-elements row actItemLk"
                [ngClass]="{'disabled': filtersApplied==true|| items.status=='BLOCKED'}">
                <div id="candidate_views_button" *ngIf="items.createdBy==userId && items.viewedByCount > 0" (click)="goTo(items, 'views')"
                  style="cursor: pointer !important;">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span class="blue-color" title="{{items.viewedByCount}} Views"> {{ items.viewedByCount | compactCount }}</span> Views
                </div>

                <div title="0 Views" *ngIf="items.createdBy==userId && items.viewedByCount == 0"
                  style="cursor: pointer!important;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span class="blue-color" title="0 Views"> 0 </span> Views
                </div>

                <div id="candidate_other_views_button" *ngIf="items.createdBy!=userId && items.viewedByCount > 0" style="cursor: context-menu!important;"
                  (click)="goTo(items, 'views')"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span id="candidate_views_count_button" title="{{items.viewedByCount}} Views" class="blue-color" (click)="goTo(items, 'Clike-like')">
                    {{ items.viewedByCount | compactCount }}</span> Views
                </div>

                <div title="0 Views" class="no-views" *ngIf="items.createdBy!=userId && items.viewedByCount == 0"
                  style="cursor: context-menu!important;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span
                    class="blue-color" title="0 Views"> 0 </span> Views
                </div>

                <div id="candidate_like_button" title="Like" (click)="like(items)" *ngIf="items?.isLiked!=null && !items?.isLiked">
                  <ng-icon name="tablerHeart" class="pointer icon-prime-color"></ng-icon>
                </div>

                <div id="candidate_unlike_button" title="Unlike" (click)="like(items)" *ngIf="items?.isLiked!=null &&  items?.isLiked">
                  <ng-icon name="tablerHeart" class="liked pointer bg-heart"></ng-icon>
                </div>
                <div style="cursor: context-menu!important;" *ngIf="items.createdBy!=userId ">
                  <span title="{{items.likesCount}} Like" *ngIf="items.likesCount>0"
                    class="blue-color">{{ items.likesCount | compactCount }}</span>
                  <span title="{{items.likesCount}} Likes" *ngIf="items.likesCount>0"> Like<span
                      *ngIf="items.likesCount>1">s </span>
                  </span>
                  <div title="0 Likes" class="no-views" *ngIf="items.createdBy!=userId && items.likesCount == 0"
                    style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Likes
                  </div>
                </div>

                <div id="candidate_likes_section_button" (click)="goTo(items, 'Clike-like')" *ngIf="items?.isLiked!=null  && items.createdBy==userId ">
                  <span title="{{items.likesCount}} Like" class="blue-color"
                    *ngIf="items.likesCount>0">{{ items.likesCount | compactCount }}</span>
                  <span id="candidate_likes_count_button" title="{{items.likesCount}} Likes" (click)="goTo(items, 'Clike-like')"
                    *ngIf="items.likesCount>0">
                    Like<span *ngIf="items.likesCount>1">s
                    </span> </span>
                  <div title="0 Likes" class="no-views" *ngIf="items.createdBy==userId && items.likesCount == 0"
                    style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Likes
                  </div>
                </div>

                <div id="candidate_invitations_button" [ngClass]="{'disabled': items.status=='INACTIVE_DUE_TO_LOW_CREDITS'}"
                  (click)="goTo(items, 'cInvited')" *ngIf="items.createdBy==userId">
                  <!-- <ng-icon name="tablerUsers" class="pointer icon-prime-color" style="padding-right: 4px;"></ng-icon> -->
                  <ng-icon name="tablerMail" class="svg-position"></ng-icon>

                  <span title="{{items.interestShownCount}} Invites" class="blue-color"
                    *ngIf="items.interestShownCount>0">{{ items.interestShownCount | compactCount }}</span>
                  <span title="0 Invites" class="blue-color" *ngIf="items.interestShownCount==0"> 0 </span>
                  <span title="{{items.appliedToday}} Invites" class="blue-color" *ngIf="items.appliedToday>0">
                    ({{items.appliedToday}} new)
                  </span>
                  Invites
                </div>

                <div id="candidate_jobs_applied_button" [ngClass]="{'disabled': items.status=='INACTIVE_DUE_TO_LOW_CREDITS'}"
                  (click)="goTo(items, 'jobsApplied')" *ngIf="items.createdBy==userId">
                  <ng-icon name="tablerUsers" class="pointer icon-prime-color" style="padding-right: 4px;"></ng-icon>
                  <span title="{{items.jobsAppliedCount}} Applied" class="blue-color"
                    *ngIf="items.jobsAppliedCount>0">{{ items.jobsAppliedCount | compactCount }}</span>
                  <span title="0 Applied" class="blue-color" *ngIf="items.jobsAppliedCount==0"> 0 </span>
                  <span title="{{items.jobsAppliedCount}} Applied" class="blue-color" *ngIf="items.appliedToday>0">
                    ({{items.appliedToday}} new)
                  </span>
                  Applied
                </div>

                <ng-container *ngFor="let newitem of items?.resumes">
                  <div *ngIf="newitem?.isDefault && items.createdBy!=userId "> <a id="candidate_download_resume_button"
                      (click)="downloadResume(items,userId,newitem.fileId)" target="_blank" download> <ng-icon name="tablerDownload"></ng-icon> Download Resume </a>
                  </div>
                </ng-container>

                <!-- <div *ngIf="items.createdBy==userId && items.resumes?.length==0"> <a>
                    <ng-icon name="tablerPaperclip" class="icon-prime-color"></ng-icon> Attach Resume </a>
                </div> -->

                <div id="candidate_request_resume_button" [ngClass]="{'disabled': items.status=='INACTIVE_DUE_TO_LOW_CREDITS'}"
                  (click)="requestResume(items, lastItem, connectionTemplate, jobsupplytemplate)" *ngIf="items.createdBy!=userId && (userType == 'RECRUITER'
                  || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
                  <a class="get-resume-icon">
                    <ng-icon name="tablerFile" class="icon-prime-color"></ng-icon>Get Resume </a>
                </div>

                <div
                  *ngIf="items.resumeRequested && items?.resumes==null && items?.resumes==undefined && items.createdBy!=userId">
                  <a style="cursor:context-menu;" download>
                    <ng-icon name="tablerCheck" class="icon-prime-color"></ng-icon> Resume Requested
                  </a>
                </div>

                <div title="Invite to Apply" [ngClass]="{'disabled': items.status=='INACTIVE_DUE_TO_LOW_CREDITS'}"
                  id="candidate_invite_apply_button" (click)="apply(items, connectionTemplate,jobsupplytemplate)"
                  *ngIf="!filtersApplied && items.createdBy!=userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
                  <ng-icon name="tablerLink" class="icon-prime-color"></ng-icon> Invite To Apply
                </div>

                <div id="candidate_chat_button" *ngIf=" items.chatHistoryCount > 0" title="{{items.nonSeenMessageCount}} Messages"
                  style="cursor: context-menu;" (click)="openMessagecheckInteraction(items, connectionTemplate)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  <span class="blue-color" *ngIf="items.nonSeenMessageCount>0">{{items.nonSeenMessageCount}}</span>
                  Chat
                </div>

                <div id="candidate_chat_no_messages_button" *ngIf="items.createdBy!=userId && items.chatHistoryCount == 0"
                  (click)="openMessagecheckInteraction(items, connectionTemplate)" title="No Messages" style="cursor: context-menu;"> <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  Chat
                </div>

                <div *ngIf="items.createdBy==userId && items.chatHistoryCount == 0" title="No Messages"
                  style="cursor: context-menu;"> <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  Chat
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ════════════════════════════════════════════════════════════════
           V3 DESIGN — Left Panel Candidate Card (jc-v3-small)
           ════════════════════════════════════════════════════════════════ -->
      <ng-container *ngIf="viewSize === 'jc-v3-small'">
        <!-- AUDIT_04 Batch 3 — V3 jc-v3-small restored to V2 functional parity:
             Connect pill, status dropdown (owner), downgrade menu, counter
             row (Views/Likes/Invites/Applied/Submitted Jobs/Get Resume/Chat),
             INACTIVE_DUE_TO_LOW_CREDITS disabled, featured-background,
             non-owner views/likes click-guard. V2 `small` block below is
             untouched (Rule 5). -->
        <div class="jc-v3-job-card"
             [ngClass]="{
               'active': selectedItem == items?.candidateId,
               'featured-background': items?.isFeatured === true,
               'jc-v3-low-credits': items?.status === 'INACTIVE_DUE_TO_LOW_CREDITS'
             }"
             (click)="onCardClick($event, items)">

          <!-- Row 1: Owner avatar + "Name @Company" + date + kebab -->
          <div class="jc-v3-jc-row1">
            <img *ngIf="items?.user?.photo" class="jc-v3-jc-av"
              [src]="getPhotoUrl(items?.user?.photo)" alt="avatar"
              (error)="$any($event.target).style.display='none'">
            <div *ngIf="!items?.user?.photo" class="jc-v3-jc-av"
              [style.background-color]="getColor(items?.user?.fullname)"
              [style.color]="getFullNameTextColor(items?.user?.fullname)">
              {{ getInitials(items?.user?.fullname) }}
            </div>
            <div class="jc-v3-jc-meta">
              <span class="jc-v3-jc-rec-name" [title]="items?.user?.fullname + (items?.postedBehalfOf ? ' @' + items?.postedBehalfOf : '')">
                {{ items?.user?.fullname }}
                <ng-container *ngIf="items?.postedBehalfOf && items?.postedBehalfOf !== 'null'">
                  &#64;{{ items?.postedBehalfOf }}
                </ng-container>
              </span>
              <span class="jc-v3-jc-date">{{ items?.createdOn | timezoneDate:'MM/dd/yyyy' }}</span>
            </div>
            <!-- Connect pill + Connected indicator removed from the
                 candidate card per wireframe — the action moved to the
                 detail header's `<app-connection-template>` block
                 (`new-candidate.component.html:311-317`) so connection
                 state is managed in one place and the card stays
                 focused on candidate identity + actions. -->
            <!-- Kebab for owner —
                 No `stopPropagation` here: it would block ngx-bootstrap's
                 document click listener and other open dropdowns (e.g. the
                 detail-header More menu) wouldn't auto-close. The parent
                 card's `onCardClick` skips `open()` when the click target
                 is inside `.jc-v3-jc-kebab`, so we still don't navigate. -->
            <div class="jc-v3-jc-kebab" [class.disabled]="items?.status === 'BLOCKED'" *ngIf="items?.createdBy === userId" dropdown
              [isOpen]="openKebabId === items?.candidateId" (isOpenChange)="onKebabToggle($event, items)" dropdownToggle>
              <span>&#8942;</span>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" style="min-width:170px;">
                <li role="menuitem"><a (click)="edit(items)"><ng-icon name="tablerEdit" style="margin-right:6px;"></ng-icon>Edit</a></li>
                <li role="menuitem"
                  *ngIf="items?.status !== 'INACTIVE' && items?.status !== 'DRAFTED' && !items?.isFeatured && userType !== 'JOB_SEEKER'"
                  (click)="upgradeCandidate(items)">
                  <a><ng-icon name="tablerCircleArrowUp" style="margin-right:6px;"></ng-icon>Upgrade Candidate</a>
                </li>
                <li role="menuitem"
                  *ngIf="items?.status !== 'INACTIVE' && items?.status !== 'DRAFTED' && items?.status !== 'INACTIVE_DUE_TO_LOW_CREDITS' && items?.isFeatured && userType !== 'JOB_SEEKER' && userType !== 'student'"
                  (click)="downgradeCandidate(items)">
                  <a><ng-icon name="tablerCircleArrowDown" style="margin-right:6px;"></ng-icon>Downgrade Candidate</a>
                </li>
                <li role="menuitem" *ngIf="items?.status === 'ACTIVE'" (click)="republishCandidate(items)">
                  <a><ng-icon name="tablerRefresh" style="margin-right:6px;"></ng-icon>Republish</a>
                </li>
                <li role="menuitem" *ngIf="items?.status === 'DRAFTED'" (click)="deletecandidate(items?.candidateId)">
                  <a><ng-icon name="tablerTrash" style="margin-right:6px;"></ng-icon>Discard</a>
                </li>
              </ul>
            </div>
            <!-- Kebab for non-owner — see owner-kebab comment above for why
                 the click handler is intentionally absent. -->
            <div class="jc-v3-jc-kebab" *ngIf="reportEnabled && items?.createdBy !== userId" dropdown
              [isOpen]="openKebabId === items?.candidateId" (isOpenChange)="onKebabToggle($event, items)" dropdownToggle>
              <span>&#8942;</span>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" style="min-width:170px;">
                <li role="menuitem" class="jc-v3-flag-item" *ngIf="reportEnabled" #flagLi
                    (click)="$event.stopPropagation(); flagLi.querySelector('app-flag p')?.click()">
                  <a>
                    <ng-icon name="tablerFlag" class="jc-v3-flag-icon" aria-hidden="true"></ng-icon>
                    Report Candidate
                  </a>
                  <app-flag type="CANDIDATE" [id]="items?.candidateId" [flagTo]="items?.createdBy" [flags]="['Report Candidate as fake.']" class="jc-v3-flag-hidden"></app-flag>
                </li>
              </ul>
            </div>
          </div>

          <!-- Row 2: Candidate name + status pill (dropdown for owner) -->
          <div class="jc-v3-jc-title-row jc-v3-cand-title-row">
            <span class="jc-v3-jc-title" [title]="items?.firstName + ' ' + items?.lastName">
              {{ items?.firstName }} {{ items?.lastName }}
            </span>
            <!-- Owner: inline status dropdown (Available ↔ Unavailable).
                 BLOCKED/DRAFTED render a static pill. Reuses the proven
                 `jc-v3-pill-dropdown` + `jc-v3-pill-toggle` + `jc-v3-pill-menu`
                 triplet from job.component.html:916-928 — that SCSS already
                 resets the <button> chrome (border:none + font-family:inherit)
                 and positions the dropdown-menu under the pill. -->
            <ng-container *ngIf="items?.createdBy === userId">
              <div class="jc-v3-pill-dropdown" dropdown
                   *ngIf="items?.status !== 'DRAFTED' && items?.status !== 'BLOCKED'"
                   [isOpen]="openStatusId === items?.candidateId"
                   (isOpenChange)="onStatusToggle($event, items)"
                   (click)="$event.stopPropagation()">
                <button type="button" dropdownToggle
                        class="jc-v3-pill jc-v3-pill-toggle"
                        [class.jc-v3-pill-green]="items?.status === 'ACTIVE'"
                        [class.jc-v3-pill-red]="items?.status === 'INACTIVE'"
                        [class.jc-v3-pill-gray]="items?.status === 'AWAITING HOST'">
                  <ng-container *ngIf="items?.status === 'ACTIVE'">Available</ng-container>
                  <ng-container *ngIf="items?.status === 'INACTIVE'">Unavailable</ng-container>
                  <ng-container *ngIf="items?.status === 'AWAITING HOST'">Awaiting Post</ng-container>
                  <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="margin-left:3px;">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </button>
                <ul *dropdownMenu class="dropdown-menu jc-v3-pill-menu" role="menu">
                  <li role="menuitem" *ngIf="items?.status !== 'ACTIVE'"
                      (click)="candidateStatus('ACTIVE', items); $event.stopPropagation()">
                    <a><span class="jc-v3-pill-dot jc-v3-pill-dot-green"></span>Available</a>
                  </li>
                  <li role="menuitem" *ngIf="items?.status !== 'INACTIVE' && items?.status !== 'AWAITING HOST'"
                      (click)="candidateStatus('INACTIVE', items); $event.stopPropagation()">
                    <a><span class="jc-v3-pill-dot jc-v3-pill-dot-red"></span>Unavailable</a>
                  </li>
                </ul>
              </div>
              <span class="jc-v3-pill jc-v3-pill-amber" *ngIf="items?.status === 'DRAFTED'">Draft</span>
              <span class="jc-v3-pill jc-v3-pill-red" *ngIf="items?.status === 'BLOCKED'">Blocked</span>
            </ng-container>
            <!-- Non-owner: static pill -->
            <ng-container *ngIf="items?.createdBy !== userId">
              <span class="jc-v3-pill jc-v3-pill-green" *ngIf="items?.status === 'ACTIVE'">Available</span>
              <span class="jc-v3-pill jc-v3-pill-red" *ngIf="items?.status === 'INACTIVE'">Unavailable</span>
              <span class="jc-v3-pill jc-v3-pill-red" *ngIf="items?.status === 'BLOCKED'">Blocked</span>
            </ng-container>
            <!-- Submitted jobs click-through (owner with submissions) -->
            <span *ngIf="items?.submittedJobsCount"
                  class="jc-v3-submitted-jobs-link"
                  title="{{items?.submittedJobsCount}} Jobs"
                  (click)="$event.stopPropagation(); submissionFilterRoute(items)">
              {{items?.submittedJobsCount}} {{ items?.submittedJobsCount > 1 ? 'Jobs' : 'Job' }}
            </span>
          </div>

          <!-- Rows 3+: Job title + hot badge + location + engagement + pay rate -->
          <div class="jc-v3-jc-details">
            <div class="jc-v3-jc-detail jc-v3-cand-jobtitle-row"
                 *ngIf="items?.jobTitle || getActiveUrgencyDays(items)">
              <span class="jc-v3-cand-jobtitle" *ngIf="items?.jobTitle" [title]="items?.jobTitle">{{ items?.jobTitle }}</span>
              <span class="urgent-hire-badge" *ngIf="getActiveUrgencyDays(items)">
                <ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Hot
              </span>
            </div>
            <div class="jc-v3-jc-detail" *ngIf="items?.city || items?.state || items?.country">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              {{ gigsumoService.formatLocation(items?.city, items?.state, items?.country) }}
            </div>
            <div class="jc-v3-jc-detail" *ngIf="items?.engagementType || items?.availableIn">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
              <ng-container *ngIf="items?.engagementType">{{ items?.engagementType }}</ng-container>
              <ng-container *ngIf="items?.engagementType && items?.availableIn"> &middot; </ng-container>
              <ng-container *ngIf="items?.availableIn">{{ items?.availableIn }}</ng-container>
            </div>
            <!-- Work Mode row intentionally omitted — the candidate card mirrors
                 the job card, which does not surface Work Mode as its own row.
                 Work Mode is still shown in the candidate detail pane (chip under
                 the title + the "Work Mode" field in Candidate Details). -->
            <!-- Rate can come back blank/null from the API; a `!= undefined`
                 guard still lets "" through and renders a half-empty
                 "– USD /" chip, so fall back to "Not Available". -->
            <div class="jc-v3-jc-detail"
                 [title]="(items?.targetRateFrom && items?.targetRateTo)
                   ? ('Employee Estimate: ' + items?.targetRateFrom + ' - ' + items?.targetRateTo + ' ' + getCurrency(items?.country) + ' / ' + getPayType(items?.payType))
                   : 'Employee Estimate: Not available'">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              <ng-container *ngIf="items?.targetRateFrom && items?.targetRateTo; else noRateCandListV3">
                {{ items?.targetRateFrom }} – {{ items?.targetRateTo }} {{ getCurrency(items?.country) }} / {{ getPayType(items?.payType) }}
              </ng-container>
              <ng-template #noRateCandListV3>Not available</ng-template>
            </div>
          </div>

          <!-- Counter row — owner sees own-listing metrics, non-owner sees interaction targets.
               INACTIVE_DUE_TO_LOW_CREDITS blanks out the interactive counts. -->
          <div class="jc-v3-jc-counter-row"
               [ngClass]="{'jc-v3-counter-disabled': items?.status === 'BLOCKED' || (items?.status === 'INACTIVE' && items?.createdBy !== userId)}">
            <!-- Views — owner clicks to Views tab; non-owner is non-interactive (parity with V2 context-menu cursor) -->
            <div class="jc-v3-jc-stat"
                 [title]="(items?.viewedByCount || 0) + ' Views'"
                 [class.jc-v3-stat-clickable]="items?.createdBy === userId"
                 (click)="$event.stopPropagation(); items?.createdBy === userId && goTo(items, items?.viewedByCount > 0 ? 'views' : 'noviews')">
              <ng-icon name="tablerEye"></ng-icon>
              <span>{{ items?.viewedByCount | compactCount }}</span>
            </div>
            <!-- Likes — single tile mirroring job-card (job.component.html:1024-1029).
                 Owner click → Likes tab. Non-owner click → like toggle (when
                 isLiked is wired). Heart turns red when isLiked. -->
            <div class="jc-v3-jc-stat"
                 [title]="(items?.likesCount || 0) + ' Likes'"
                 [class.jc-v3-stat-clickable]="items?.createdBy === userId || items?.isLiked != null"
                 (click)="$event.stopPropagation();
                          items?.createdBy === userId
                            ? goTo(items, 'Clike-like')
                            : (items?.isLiked != null && like(items))">
              <svg width="10" height="10" viewBox="0 0 24 24" [attr.fill]="items?.isLiked ? '#F43F5E' : 'none'" [attr.stroke]="items?.isLiked ? '#F43F5E' : 'currentColor'" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
              <span>{{ items?.likesCount | compactCount }}</span>
            </div>
            <!-- Invites (owner) -->
            <div class="jc-v3-jc-stat jc-v3-stat-clickable"
                 *ngIf="items?.createdBy === userId"
                 [title]="(items?.interestShownCount || 0) + ' Invites' + (items?.appliedToday > 0 ? ' (' + items?.appliedToday + ' new)' : '')"
                 (click)="$event.stopPropagation(); goTo(items, 'cInvited')">
              <ng-icon name="tablerMail"></ng-icon>
              <span>{{ items?.interestShownCount | compactCount }}</span>
            </div>
            <!-- Jobs Applied (owner) — disabled when low credits -->
            <div class="jc-v3-jc-stat jc-v3-stat-clickable"
                 *ngIf="items?.createdBy === userId"
                 [ngClass]="{'jc-v3-stat-disabled': items?.status === 'INACTIVE_DUE_TO_LOW_CREDITS'}"
                 title="{{items?.jobsAppliedCount || 0}} Applied"
                 (click)="$event.stopPropagation(); goTo(items, 'jobsApplied')">
              <ng-icon name="tablerSend"></ng-icon>
              <span>{{ items?.jobsAppliedCount | compactCount }}</span>
            </div>
            <!-- Get Resume (non-owner recruiter, no active request) -->
            <div class="jc-v3-jc-stat jc-v3-stat-clickable"
                 *ngIf="shouldShowGetResume(items) && items?.createdBy !== userId && (userType === 'RECRUITER' || userType === 'FREELANCE_RECRUITER' || userType === 'MANAGEMENT_TALENT_ACQUISITION')"
                 [ngClass]="{'jc-v3-stat-disabled': duplicateresume}"
                 title="Request resume"
                 (click)="$event.stopPropagation(); requestResume(items, lastItem, connectionTemplate, jobsupplytemplate)">
              <ng-icon name="tablerFile"></ng-icon>
            </div>
            <!-- Requested confirmation badge -->
            <div class="jc-v3-jc-stat jc-v3-stat-requested"
                 *ngIf="shouldShowRequested(items)"
                 title="Resume requested">
              <ng-icon name="tablerCheck"></ng-icon>
            </div>
            <!-- Chat — non-owner always (initiate or continue), owner only when messages exist -->
            <!-- *ngIf="items?.createdBy !== userId || items?.chatHistoryCount > 0" -->
            <div class="jc-v3-jc-stat jc-v3-stat-clickable"
                 [title]="items?.nonSeenMessageCount > 0 ? (items?.nonSeenMessageCount + ' Messages') : 'No Messages'"
                 (click)="$event.stopPropagation(); openMessagecheckInteraction(items, connectionTemplate)">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              <span *ngIf="items?.nonSeenMessageCount > 0" class="jc-v3-chat-unseen">{{ items?.nonSeenMessageCount }}</span>
            </div>
            <!-- Download default resume (non-owner) -->
            <ng-container *ngFor="let resume of items?.resumes">
              <div class="jc-v3-jc-stat jc-v3-stat-clickable"
                   *ngIf="resume?.isDefault && items?.createdBy !== userId"
                   title="Download Resume"
                   (click)="$event.stopPropagation(); downloadResume(items, userId, resume?.fileId)">
                <ng-icon name="tablerDownload"></ng-icon>
              </div>
            </ng-container>
            <!-- Invite to Apply (non-owner recruiter) — placed last so the
                 `.jc-v3-jc-apply-btn { margin-left: auto }` rule pushes it
                 to the right end of the row, mirroring job-card's Apply. -->
            <button class="jc-v3-jc-apply-btn"
                    *ngIf="!filtersApplied && items?.createdBy !== userId && (userType === 'RECRUITER' || userType === 'FREELANCE_RECRUITER' || userType === 'MANAGEMENT_TALENT_ACQUISITION')"
                    [class.disabled]="gigsumoService?.candidateInviteBtnClicked"
                    (click)="$event.stopPropagation(); apply(items, connectionTemplate, jobsupplytemplate)"
                    title="Invite to Apply">Invite</button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="viewSize === 'small'">
        <div class="hpanel">
          <div id="jobBody" class="panel-body border-radius-top-left-right-6" [ngClass]="{
            'disabled': !items.availability,
            'pad-0': viewSize == 'small',
            'featured-background': items.isFeatured==true,
            'highLightList' : selectedItem == items?.candidateId}">
            <ng-container>

              <div class="profile-card pad-10-10-10-10">
                <div class="bottom-section row">
                  <div class="col-sm-2" style="margin-top:5px;">
                    <div class="top-section">
                      <div *ngIf="items?.user?.photo" class="user-img">
                        <img [src]="getPhotoUrl(items?.user?.photo)" alt="profile-picture">
                      </div>
                      <div class="user-img" *ngIf="!items?.user?.photo">
                        <div class="circles mr-rt-10" [style.background-color]="getColor(items?.user?.fullname)">
                          <div class="circle-text" [style.color]="getFullNameTextColor(items?.user?.fullname)">{{ getInitials(items?.user?.fullname) }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="xs-btn-container">
                      <div *ngIf="items?.connectionStatus == 'CONNECTED'">
                        <ng-icon name="tablerLink" class="link primary-color" title="You are connected with this owner"></ng-icon>
                      </div>
                      <div *ngIf="items?.connectionStatus == 'NOT_CONNECTED'||items?.connectionStatus == 'REJECTED'|| items?.connectionStatus == 'CANCELLED'">
                        <button id="candidate_connect_button" class="btn btn-xs btn-primary pad-0-3" (click)="connect(items) ">
                          Connect
                        </button>
                      </div>
                    </div>
                  </div>
                  <div id="candidate_small_view_content" class="col-sm-10 pad-lt-18 job-route-content" (click)="open(items)">
                    <div class="user-info-job">
                      <div class="user-name">{{ (items?.user?.fullname?.length > 10) ? (items?.user?.fullname |
                        slice:0:15) +
                        ".." : (items?.user?.fullname)}}</div>
                      <span *ngIf="items.postedBehalfOf && items.postedBehalfOf !== null" style="color: rgb(0 0 0)"> &#64;</span>
                      <div class="current-org" title="{{items.postedBehalfOf}}">{{items.postedBehalfOf}}</div>
                    </div>
                    <div class="user-info-job">
                      <div style="display: inline-flex; align-items: center;">
                        <ng-icon name="tablerClock" style="margin-right: 3px;margin-top: 2px;"></ng-icon>
                        <small class="time-stamp">
                          {{ items?.createdOn | timezoneDate:'MM/dd/yyyy' }}
                        </small>
                      </div>
                    </div>
                    <div class="candidate-name" title="{{items.firstName + ' ' + items.lastName}}">{{items.firstName + "
                      " +
                      items.lastName}}</div>
                    <div class="job-title" title="{{items.jobTitle}}">{{items.jobTitle}}</div>
                    <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(items) as urgencyDays">
                      <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Hot</span>
                    </div>

                    <div class="client-location" title="{{ gigsumoService.formatLocation(items?.city, items?.state, items?.country) }}">
                      <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                      {{ gigsumoService.formatLocation(items?.city, items?.state, items?.country) }}
                    </div>
                    <div class="details">
                      <div *ngIf="items.showClientName" title="{{items.clientName}}" class="client-name">
                        <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
                        {{items.clientName | truncate:20}}
                      </div>
                      <div *ngIf="items?.engagementType"  title="{{items.engagementType}}" class="client-type">
                        <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                        {{items.engagementType}}
                      </div>
                      <div *ngIf="items?.availableIn"  title="{{items.availableIn}}" class="availability">
                        <ng-icon name="tablerCalendar" class="svg-position"></ng-icon>
                        {{items.availableIn}}
                      </div>
                      <div class="job-relocation"  *ngIf="items?.workMode=='Remote'">
                        <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                        Remote
                      </div>
                      <div [title]="'Pay Rate: ' +
                                            (items?.country === 'US' ? '$' : '') +
                                            items?.targetRateFrom + ' - ' + items?.targetRateTo + ' ' +
                                            getCurrency(items?.country) + ' / ' +
                                            getPayType(items?.payType)"
                        *ngIf="items?.targetRateFrom != undefined && items?.targetRateTo != undefined" class="job-pay">
                        Pay Rate:
                        <span>
                          {{items?.country === 'US' ? '$' : ''}}
                          {{items?.targetRateFrom}} - {{items?.targetRateTo}}
                        </span>
                        <span>{{getCurrency(items?.country)}} / {{getPayType(items?.payType)}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="candidate-action">
                    <div class="user-action">
                      <div [ngClass]="{'disabled':items.status=='BLOCKED'}" class="btn-group "
                        *ngIf="items.createdBy==userId" dropdown>
                        <ng-icon name="tablerDotsVertical" dropdownToggle class="svg-position cursor-pointer"></ng-icon>
                        <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu upgrade-t" role="menu"
                          style="right: 0; left: auto; z-index: 2;" aria-labelledby="button-animated">
                          <li role="menuitem" *ngIf=" items.createdBy==userId">
                            <a id="candidate_small_edit_button" (click)="edit(items)">
                              <ng-icon name="tablerEdit" aria-hidden="true"></ng-icon> Edit
                            </a>
                          </li>
                          <li id="candidate_small_upgrade_button" (click)="upgradeCandidate(items)" role="menuitem"
                            *ngIf="items.createdBy==userId  && items.status!='INACTIVE'   && items.status!='DRAFTED' && items.isFeature=='null'   && userType !='JOB_SEEKER'  ||   !items.isFeatured  && items.status!='INACTIVE' && items.status!='DRAFTED'&&  items.status!='INACTIVE_DUE_TO_LOW_CREDITS'  &&items.createdBy==userId   && userType !='JOB_SEEKER' ">
                            <a>
                              <ng-icon name="tablerCircleArrowUp" aria-hidden="true"></ng-icon> Upgrade Candidate
                            </a>
                          </li>
                          <li id="candidate_small_downgrade_button" (click)="downgradeCandidate(items)" role="menuitem"
                            *ngIf="items.createdBy==userId  && items.status!='INACTIVE'  && items.status!='DRAFTED'  && items.isFeatured   && userType !='JOB_SEEKER'  ||   items.isFeatured  && items.status!='INACTIVE' && items.status!='DRAFTED' && items.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& items.createdBy==userId &&  userType !='student' && userType !='JOB_SEEKER' ">
                            <a>
                              <ng-icon name="tablerCircleArrowDown" aria-hidden="true"></ng-icon> Downgrade Candidate
                            </a>
                          </li>
                          <li id="candidate_small_republish_button" (click)="republishCandidate(items)" role="menuitem"
                            *ngIf="items.createdBy==userId && items.status=='ACTIVE'">
                            <a>
                              <ng-icon name="tablerRefresh" aria-hidden="true"></ng-icon> Republish
                            </a>
                          </li>
                          <li id="candidate_small_delete_button" (click)="deletecandidate(items.candidateId)" role="menuitem"
                            *ngIf="items.createdBy==userId  && items.status=='DRAFTED'">
                            <a>
                              <ng-icon name="tablerTrash" aria-hidden="true"></ng-icon> Discard
                            </a>
                          </li>
                        </ul>
                      </div>

                      <!-- Non-owner kebab, report-only - see the note on the large
                           card's kebab above. -->
                      <div class="btn-group pull-right" *ngIf="reportEnabled && items.createdBy!=userId" dropdown>
                        <ng-icon name="tablerDotsVertical" dropdownToggle class="svg-position cursor-pointer"></ng-icon>
                        <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu upgrade-t" role="menu"
                          style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                          <li role="menuitem" class="report" *ngIf="reportEnabled"
                            style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                            <app-flag type="CANDIDATE" [id]="items.candidateId" [flagTo]="items.createdBy"
                              [flags]="['Report Candidate as fake.']">
                            </app-flag>
                          </li>
                          <li id="candidate_small_upgrade_button2" (click)="upgradeCandidate(items)" role="menuitem"
                            *ngIf=" items.createdBy==userId && items.isFeature=='null'  &&  userType !='student' && userType !='JOB_SEEKER'  ||   !items.isFeatured && items.createdBy==userId &&  userType !='student' && userType !='JOB_SEEKER' ">
                            <a>
                              Upgrade Candidate
                            </a>
                          </li>
                        </ul>

                      </div>
                      <div id="top-unset" [ngClass]="{'disabled':items.status=='BLOCKED'}" class="btn-group" dropdown
                        *ngIf="items.createdBy==userId ">
                        <div [class.pntr]="items.status !='DRAFTED' &&filtersApplied==false"
                          *ngIf="items.status !='DRAFTED' &&filtersApplied==false"
                          data-toggle="dropdown" dropdownToggle class="br-pd-1"
                          aria-expanded="true"
                          [ngClass]="{'active-label': (items.status === 'ACTIVE' && items.createdBy==userId),
                          'active-non-owner-label': (items.status === 'ACTIVE' && items.createdBy!=userId),
                                                                'inactive-label':(items.status === 'INACTIVE'),
                                                                'onhold-label':(items.status === 'ON HOLD'),
                                                                'closed-label':(items.status === 'CLOSED'),
                                                                'filled-label':(items.status === 'FILLED'),
                                                                'deactivated-label':(items.status === 'BLOCKED'),
                                                                }">
                          <ng-container *ngIf="items.status=='ACTIVE'"> Available</ng-container>
                          <ng-container *ngIf="items.status=='INACTIVE'">Unavailable</ng-container>
                          <ng-container *ngIf="items.status=='AWAITING HOST'">Awaiting Post</ng-container>
                          <ng-container *ngIf="items.status=='BLOCKED'">Blocked</ng-container>
                          <ng-icon name="tablerChevronDown" style="margin-left:9px;float:right; margin-top: 6px;"
                            aria-hidden="true"></ng-icon>
                        </div>
                        <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-animated">
                          <li role="menuitem" *ngIf="items.status!='ACTIVE'&& items.status !='DRAFTED' "
                            (click)="candidateStatus('ACTIVE',items)" id="ACTIVE">
                            <a id="ACTIVE"> <ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon>
                              Available
                            </a>
                          </li>
                          <li role="menuitem"
                            *ngIf="items.status!='INACTIVE' && items.status !='DRAFTED'&& items.status !='AWAITING HOST'"
                            (click)="candidateStatus('INACTIVE',items)" id="INACTIVE">
                            <a id="INACTIVE"> <ng-icon name="tablerCircle" class="fs-status-icon t-filled" aria-hidden="true"></ng-icon>
                              Unavailable </a>
                          </li>
                          <!-- <li class="disabled" role="menuitem" id="Deactivated">
                            <a id="Deactivated"> <ng-icon name="tablerCircle" class="fs-status-icon t-close" aria-hidden="true"></ng-icon>
                              Deactivated </a>
                          </li> -->
                        </ul>
                      </div>
                      <div id="jb_dpDown" class="btn-group" dropdown *ngIf="items.createdBy==userId ">
                        <div *ngIf="items.status=='DRAFTED'"
                        class="br-pd-1 draft-label">Draft</div>
                      </div>
                      <div id="jb_dpDown" class="btn-group" dropdown *ngIf="items.createdBy!=userId  ">
                        <div
                          *ngIf="items.status !='DRAFTED'&& items.status !='INACTIVE_DUE_TO_LOW_CREDITS'&&filtersApplied==false||items.status=='ACTIVE'"
                          data-toggle="dropdown" dropdownToggle
                          aria-expanded="true"
                          class="br-pd-1"
                          [ngClass]="{'active-label': (items.status === 'ACTIVE' && items.createdBy==userId),
                          'active-non-owner-label': (items.status === 'ACTIVE' && items.createdBy!=userId),
                                                                'inactive-label':(items.status === 'INACTIVE'),
                                                                'onhold-label':(items.status === 'ON HOLD'),
                                                                'closed-label':(items.status === 'CLOSED'),
                                                                'filled-label':(items.status === 'FILLED'),
                                                                 }">
                          <ng-container *ngIf="items.status=='ACTIVE'"> Available</ng-container>
                          <ng-container *ngIf="items.status=='INACTIVE'"> Unavailable</ng-container>
                        </div>
                      </div>
                    </div>
                    <div id="candidate_submission_filter_button" (click)="submissionFilterRoute(items)" *ngIf="items.submittedJobsCount"
                      class="applied-jobs-count">
                      {{items?.submittedJobsCount}} {{items?.submittedJobsCount > '1' ? 'Jobs' : 'Job'}}
                    </div>

                  </div>
                </div>
              </div>


              <div class="interaction-section"
                [ngClass]="{'disabled': items.status=='BLOCKED'||items.status=='INACTIVE'&&items.createdBy!=userId}">
                <div class="interaction-element pad-5-3" *ngIf="items.createdBy==userId && items.viewedByCount > 0"
                  (click)="goTo(items, 'views')" style="cursor: pointer !important;">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span class="blue-color " title="{{items.viewedByCount}} Views"> {{ items.viewedByCount | compactCount }}</span>
                  Views
                </div>
                <div class="interaction-element pad-5-3" title="0 Views"
                  *ngIf="items.createdBy==userId && items.viewedByCount == 0" style="cursor: pointer!important;">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span class="blue-color " title="0 Views"> 0 </span> Views
                </div>
                <div class="interaction-element pad-5-3" *ngIf="items.createdBy!=userId && items.viewedByCount > 0"
                  style="cursor: context-menu!important;">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span id="candidate_small_views_count_button" title="{{items.viewedByCount}} Views" class="blue-color " (click)="goTo(items, 'Clike-like')">
                    {{ items.viewedByCount | compactCount }}</span> Views
                </div>
                <div class="interaction-element pad-5-3" title="0 Views"
                  *ngIf="items.createdBy!=userId && items.viewedByCount == 0" style="cursor: context-menu!important;">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span class="blue-color" title="0 Views"> 0
                  </span> Views
                </div>
                <div id="candidate_small_like_button" class="interaction-element pad-5-3" title="Like" (click)="like(items)"
                  *ngIf="items?.isLiked!=null && !items?.isLiked">
                  <ng-icon name="tablerHeart" class="pointer icon-prime-color"></ng-icon>
                </div>
                <div id="candidate_small_unlike_button" class="interaction-element pad-5-3" title="Unlike" (click)="like(items)"
                  *ngIf="items?.isLiked!=null &&  items?.isLiked">
                  <ng-icon name="tablerHeart" class="liked pointer bg-heart"></ng-icon>
                </div>
                <div class="interaction-element pad-5-3" style="cursor: context-menu!important;"
                  *ngIf="items.createdBy!=userId ">
                  <div title="{{items.likesCount}} Like" *ngIf="items.likesCount>0" class="blue-color">
                    {{ items.likesCount | compactCount }}
                  </div>
                  <span title="{{items.likesCount}} Likes" *ngIf="items.likesCount>0"> Like<span
                      *ngIf="items.likesCount>1">s </span>
                  </span>
                  <div title="0 Likes" class="no-views" *ngIf="items.createdBy!=userId && items.likesCount == 0"
                    style="cursor: context-menu!important;">
                    <span class="blue-color" title="0 Likes">
                      0
                    </span>
                  </div>
                  <div *ngIf="items.createdBy!=userId && items.likesCount == 0" style="cursor: context-menu!important;">
                    Likes
                  </div>
                </div>
                <div id="candidate_small_likes_section_button" (click)="goTo(items, 'Clike-like')" class="interaction-element pad-5-3"
                  *ngIf="items?.isLiked!=null  && items.createdBy==userId ">
                  <div title="{{items.likesCount}} Like" class="blue-color" *ngIf="items.likesCount>0">
                    {{ items.likesCount | compactCount }}
                  </div>
                  <span id="candidate_small_likes_count_button" title="{{items.likesCount}} Likes" (click)="goTo(items, 'Clike-like')"
                    *ngIf="items.likesCount>0">
                    Like<span *ngIf="items.likesCount>1">s</span>
                  </span>
                  <div title="0 Likes" class="no-views" *ngIf="items.createdBy==userId && items.likesCount == 0"
                    style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like
                  </div>
                </div>
                <div id="candidate_small_invitations_button" class="interaction-element pad-5-3" (click)="goTo(items, 'cInvited')"
                  *ngIf="items.createdBy==userId">
                  <ng-icon name="tablerMail" class="svg-position"></ng-icon>

                  <span title="{{items.interestShownCount}} Invites" class="blue-color"
                    *ngIf="items.interestShownCount>0">{{ items.interestShownCount | compactCount }}</span>
                  <span title="0 Invites" class="blue-color" *ngIf="items.interestShownCount==0"> 0 </span>
                  <span title="{{items.appliedToday}} Invites" class="blue-color" *ngIf="items.appliedToday>0">
                    ({{items.appliedToday}} new)
                  </span>
                  Invites
                </div>
                <div id="candidate_small_jobs_applied_button" class="interaction-element pad-5-3"
                  [ngClass]="{'disabled': items.status=='INACTIVE_DUE_TO_LOW_CREDITS'}"
                  (click)="goTo(items, 'jobsApplied')" *ngIf="items.createdBy==userId">
                  <ng-icon name="tablerSend" class="svg-position"></ng-icon>
                  <span title="{{items.jobsAppliedCount}} Applied" class="blue-color"
                    *ngIf="items.jobsAppliedCount>0">{{ items.jobsAppliedCount | compactCount }}</span>
                  <span title="0 Applied" class="blue-color" *ngIf="items.jobsAppliedCount==0"> 0 </span>
                  Applied
                </div>
                <!-- <div class="interaction-element pad-5-3" *ngIf="items.createdBy==userId && items.resumes?.length==0">
                  <a><ng-icon name="tablerPaperclip" class="icon-prime-color"></ng-icon> Attach Resume </a>
                </div> -->
                <!-- <div class="interaction-element pad-5-3" [ngClass]="{'disabled': duplicateresume}"
                  (click)="requestResume(items, lastItem, connectionTemplate, jobsupplytemplate)"
                  *ngIf="items.createdBy != userId &&!items.resumeRequestedWithoutJobReference">
                  <a class="get-resume-icon">
                    <ng-icon name="tablerFile" class="icon-prime-color"></ng-icon>Get Resume </a>
                </div>

                <div class="interaction-element pad-5-3"
                  *ngIf="(resumeRequestedMap.get(items.candidateReferenceId)||items.resumeRequestedWithoutJobReference) && items.createdBy != userId &&activejobcount==0">
                  <a style="cursor:context-menu;" download>
                    <ng-icon name="tablerCheck" class="icon-prime-color"></ng-icon> Requested
                  </a>
                </div> -->
                <div id="candidate_small_get_resume_button" class="interaction-element pad-5-3" [ngClass]="{'disabled': duplicateresume}"
                  (click)="requestResume(items, lastItem, connectionTemplate, jobsupplytemplate)" *ngIf="shouldShowGetResume(items)&& items.createdBy!=userId && (userType == 'RECRUITER'
                  || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
                  <a class="get-resume-icon">
                    <ng-icon name="tablerFile" class="icon-prime-color"></ng-icon>Get Resume</a>
                </div>

                <div class="interaction-element pad-5-3" *ngIf="shouldShowRequested(items)">
                  <a style="cursor:context-menu;" download>
                    <ng-icon name="tablerCheck" class="icon-prime-color"></ng-icon> Requested
                  </a>
                </div>


                <div id="candidate_small_invite_apply_button" class="interaction-element pad-5-3" title="Invite to Apply"
                  [ngClass]="{'disabled':  gigsumoService?.candidateInviteBtnClicked}"
                  (click)="apply(items, connectionTemplate,jobsupplytemplate)" *ngIf="!filtersApplied && items.createdBy!=userId && (userType == 'RECRUITER'
                || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
                  <ng-icon name="tablerMail" class="svg-position"></ng-icon>
                  Invite
                </div>

                <div id="candidate_small_chat_button" class="interaction-element pad-5-3" *ngIf=" items.chatHistoryCount > 0"
                  title="{{items.nonSeenMessageCount}} Messages" (click)="openMessagecheckInteraction(items, connectionTemplate)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color mr-rt-5" style="font-size: 14px;"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  <span class="blue-color" *ngIf="items.nonSeenMessageCount>0">{{items.nonSeenMessageCount}}</span>
                  Chat
                </div>

                <div id="candidate_small_chat_no_messages_button" class="interaction-element pad-5-3" *ngIf="items.createdBy!=userId && items.chatHistoryCount == 0"
                  (click)="openMessagecheckInteraction(items, connectionTemplate)" title="0 Messages">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color mr-rt-5" style="font-size: 14px;"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  Chat
                </div>


                <div class="interaction-element pad-5-3" *ngIf="items.createdBy==userId && items.chatHistoryCount == 0"
                  title="0 Messages">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color mr-rt-5" style="font-size: 14px;"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  Chat
                </div>
                <div class="interaction-element pad-5-3" title="Download Resume" *ngFor="let newitem of items?.resumes">
                  <span *ngIf="newitem?.isDefault && items.createdBy != userId">
                    <a id="candidate_small_download_resume_button" (click)="downloadResume(items, userId, newitem.fileId)" target="_blank" download>
                      <ng-icon name="tablerDownload" class="mr-rt-5 icon-prime-color"></ng-icon> Download
                    </a>
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="viewSize === 'extra-small'">
        <div class="hpanel mr-bt-4px" *ngIf = "!loadApply">
          <div  class="panel-body border-radius-top-left-right-6 pad-6-0 element-flex-parent" style="padding: 20px 24px 20px 0px !important;" [ngClass]="{
                      'disabled': !items.availability || (items?.status !='ACTIVE' && items?.createdBy != userId),
                      'pad-10-10-10-10': viewSize == 'small',
                      'featured-background': items.isFeatured==true
                     }">
            <div class="xs-entity-details-container">
              <div class="xs-entity-select-checkbox">
                <div class="custom-checkbox em xs-submit-checkbox-position"
                  *ngIf="items.currentStatus == undefined && (items.inviteStatus == undefined || items.inviteStatus == 'INITIATED')">
                  <label class="checkbox-label font-bold" style="text-align: center">
                    <input #selected type="checkbox" [(ngModel)]="items.isSelected" value="{{items?.user?.userId}}"
                      (change)="selectCheckbox($event, items?.candidateId, i)" />
                    <span id="ApplyCandidates" class="checkmark"></span>
                  </label>
                </div>
              </div>


              <div *ngIf="items?.photo" class="xs-entity-owner-img">
                <img [src]="getPhotoUrl(items?.photo)" alt="profile-picture">
              </div>
              <div *ngIf="!items?.photo">
                <div class="circles" [style.background-color]="getColorName(items?.firstName,items.lastName)">
                <div class="circle-text" [style.color]="getTextColor(items?.firstName, items?.lastName)"
                  style=" font-family: Arial,sans-serif; font-weight: bold; font-size: 16px;">
                    {{ getInitialName(items?.firstName,items.lastName) }}</div>
                </div>
 
                
              </div>
              <div class="xs-entity-details">
                <div title="{{items?.firstName + ' ' + items?.lastName}}" class="user-name-sm">{{ (items?.firstName + " " +
                  items?.lastName).length > 10 ? ((items?.firstName +
                  " " + items?.lastName) |
                  slice:0:10) + "..":
                  (items?.firstName + " " + items?.lastName)}}</div>
                <div class="xs-candidate-title" title="{{items?.jobTitle}}">{{items?.jobTitle}}</div>
              </div>
            </div>

            <div class="xs-rate-container" id="rateconfirmationfrom" [formGroup]="rtrformgrp">
              <section formArrayName="rtrcontent">
                <div *ngFor="let item of rtrContent?.controls; let rtrIndex = index" [formGroupName]="i">

                  <div *ngIf="rtrIndex === i">
                    <div class="app-form xs-pay-rate-container">
                      <div class="targetRate">
                        <input id="myText" (keypress)="decimalFilter($event)" maxlength="8"
                          class="form-control input-sm common-rtr" formControlName="targetrate" />
                        <small class="error-msg"
                          *ngIf="item.get('targetrate').errors?.required && (item.get('targetrate')?.dirty || item.get('targetrate')?.touched)">
                          Target Rate is required</small>
                        <small class="error-msg" *ngIf="item.get('targetrate').errors?.invalidDecimal">
                          {{FORMERROR.TARGETRATE_PATTERN}}
                        </small>
                      </div>
                      <div class="currency">
                        <span *ngIf="item?.get('country').value === 'US'"> USD </span>
                        <span *ngIf="item?.get('country').value === 'IN'"> INR </span>
                        <span *ngIf="item?.get('country').value === 'CA'"> CAD </span>
                        <span *ngIf="item?.get('country').value === 'DZ'"> AUD </span>
                      </div>
                    </div>
                    <div class="app-form  xs-pay-type-container">
                      <small class="paytype">
                        <select formControlName="RtrpayType" type="text" class="form-control input-sm" style="padding: 13px;">
                          <option value=null disabled selected hidden>Choose Type</option>
                          <option value="Hourly">Hourly</option>
                          <option value="Daily">Daily</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                          <option value="Yearly">Yearly</option>
                        </select>
                        <span class="error tar-job"
                          *ngIf="item.get('RtrpayType').errors?.required &&
                                                    (item.get('RtrpayType')?.dirty || item.get('RtrpayType')?.touched) ">Paytype
                          required</span>
                      </small>
                    </div>


                  </div>
                </div>
              </section>
            </div>

            <div class="xs-candidate-status">
              <div class="xs-line-one-status">
                <div class="status-label" style="color:#fff;"
                  *ngIf="items.currentStatus!=null || items.inviteStatus!=null;"
                  [ngStyle]="getStatusLabelStyle(items)">
                  <ng-container> {{ getFilterValue(items) | titlecase }}
                  </ng-container>
                </div>
                <div id="candidate_attach_resume_button" (click)="openJobApplyResumeUpload(Resumetemplate , i)" class="btn btn-info btn-xs pd-0-2"
                  *ngIf="items.isSelected && getResumeError(i)?.required">
                  Attach Resume
                  <span>
                    <ng-icon name="tablerPaperclip"></ng-icon>
                  </span>
                </div>
                <div class="status-label" style="background: #8B5CF6;" title="Resume Attached"
                  *ngIf="items.isSelected && !getResumeError(i)?.required">
                  Resume &#10004;&#65038;
                </div>
                <ng-template #statusShow>
                  <div class="status-label" *ngIf="filtersApplied" [style.background-color]="getButtonColor(items)"
                    style="color:white">
                    <span *ngIf="filtersApplied && items.currentStatus==null">Available</span>
                  </div>
                  <div class="status-label btn-warning" *ngIf="items.status=='DRAFTED'">Draft</div>
                </ng-template>
              </div>
              <div class="xs-line-two-status">
                <div class="error-msg" *ngIf="items.isSelected && getResumeError(i)?.required">
                  <div>Resume required</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <app-common-skeleton *ngIf="viewSize === 'extra-small' && loadApply" [countforView]="4" [NameOftheScreen]="'applyCandidateXs'">
    </app-common-skeleton>
    <app-common-skeleton *ngIf="(viewSize === 'small' || viewSize === 'jc-v3-small') && loadAPIcall" [countforView]="2" [NameOftheScreen]="'jobcardMediumscreen'">
    </app-common-skeleton>
  </div>
  <div class="jc-v3-list-empty" *ngIf="viewSize === 'jc-v3-small' && passValues.length===0 && !loadAPIcall">
    <ng-icon name="tablerUserSearch"></ng-icon>
    <p>{{ candidatesFoundStatus }}</p>
  </div>
  <div class="wert" *ngIf="viewSize !== 'jc-v3-small' && passValues.length===0 && !loadAPIcall">
    <div class="col-md-12 mg-bt-9">
        <ng-icon name="tablerUserSearch"></ng-icon>
        <!-- <ng-icon name="customSearchCross" *ngIf="responseReceived"></ng-icon> -->
      <!-- <ng-icon name="tablerUserSearch" *ngIf="!responseReceived"></ng-icon> -->
    </div>
    <div class="col-md-12 fig">{{candidatesFoundStatus}} </div>
  </div>
  <div *ngIf="viewSize == 'extra-small' && passValues.length > 0" class="xs-tc-checkbox-container">
    <!-- <label for="termsCheckBox">
      <input (change)="terms($event.target.checked)" type="checkbox" class="termCheck" id="termsCheckBox" />
      I warrant that I have an exclusive right to represent this candidate for the applied position
    </label> -->

    <div class="custom-checkbox">
      <label class="checkbox-label font-normal"> I warrant that I have an exclusive right to represent this candidate
        for
        the applied position
        <input (change)="terms($event.target.checked)" type="checkbox" id="termsCheckBox">
        <span class="checkmark"></span>
      </label>
    </div>

    <div class="error" *ngIf="!termAndCondition">
      Please accept to the above statement by checking it
    </div>
  </div>
</div>
<ng-template #noResult>
  <div class="jc-v3-list-empty" *ngIf="viewSize === 'jc-v3-small' && candidatesFoundStatus && candidatesFoundStatus.length > 0">
    <ng-icon name="tablerUserSearch"></ng-icon>
    <p>{{ candidatesFoundStatus }}</p>
  </div>
  <div class="wert" *ngIf="viewSize !== 'jc-v3-small' && candidatesFoundStatus && candidatesFoundStatus.length > 0">
    <div class="col-md-12 mg-bt-9">
        <ng-icon name="tablerUserSearch"></ng-icon>
        <!-- <ng-icon name="customSearchCross" *ngIf="responseReceived"></ng-icon> -->
      <!-- <ng-icon name="tablerUserSearch" *ngIf="!responseReceived"></ng-icon> -->
    </div>
    <div class="col-md-12 fig">{{candidatesFoundStatus}} </div>
  </div>
</ng-template>
<ng-template #connectionTemplate>
  <app-connection-template [page]="'candidate-listing'" [connectionStatus]="connectionStatus"
    [counterpartsDetails]="counterpartsDetails" [values]="values" [module]="'candidate'"></app-connection-template>
</ng-template>


<app-candidate-template (updateStatusAndFilters)="oncandidateFilterReload($event)" (candidateReload)="oncandidateReload($event)"></app-candidate-template>


<ng-template #Resumetemplate>
  <div class="common-header-flex">
    <div> Resume Upload </div>
    <button>
      <span id="candidate_modal_close_button" class="common-close" (click)="close()">×</span>
    </button>
  </div>

  <div class="panel-body">
<!-- 
    <div class="col-sm-12" style="margin-top: 17px;">
 
      <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
        <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
          (change)="fileBrowseHandler($event.target.files)" />
        <i class="file-icon-908"></i>
        <div>
          <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
        </div>
        <div>
          <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this area.</label>
        </div>
        <div>
          <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
        </div>
      </div>
      <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
        <span class="file-name-908">{{fileDragdrop?.name | truncate: 28}}</span>
        <ng-icon name="tablerX" id="candidate_file_remove_svg_button" class="svg-position file-remove-908"  (click)="removeFiles()"></ng-icon>
        <button id="candidate_file_remove_button" class="file-remove-908" (click)="removeFiles()">×</button>
      </div>
    </div> -->

    <!-- <div class="resume-files-list" *ngIf="fileDragdrop">
      <div class="single-files">
        <div class="info">
          <h4 class="name">
            {{ fileDragdrop?.name }}
          </h4>
          <p id="candidate_download_file_button" title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
            <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
          </p>
          <div id="candidate_remove_file_button" (click)="removeFile()" title="Remove File" class="tiimes">x</div>
        </div>
      </div>
    </div> -->

    
    <div  class="col-sm-12" style="margin-top: 17px;">
      <div class="dropdox-908"
           appDnd
           (fileDropped)="onFileDropped($event)">
        <!-- The input lives INSIDE a full-box <label> (implicit association) so
             a click anywhere in the box opens the picker natively. The previous
             (click)="clearAndOpenFileInput()" relied on
             @ViewChild('fileDropRef'), which does NOT resolve because this
             dropzone is inside an <ng-template> rendered by ngx-bootstrap's
             modalService (a separate view) — so this.fileDropRef was undefined
             and the .click() never fired. A native label needs no
             @ViewChild / id / programmatic click. Preview stays OUTSIDE the
             label so the × doesn't re-open the picker. -->
        <label class="resume-drop-label" style="display:block; width:100%; margin:0; cursor:pointer;">
          <input
            #fileDropRef
            style="display: none"
            type="file"
            accept=".pdf,.doc,.docx,.txt"
            (click)="fileDropRef.value=''"
            (change)="fileBrowseHandler($event.target.files)" />

          <span class="file-icon-908">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="12" y1="18" x2="12" y2="12"></line>
              <line x1="9" y1="15" x2="15" y2="15"></line>
            </svg>
          </span>
          <span class="upload-title-908" style="display:block;">Upload Your Resume</span>
          <span class="upload-instruction-908" style="display:block;" id="aad">Drag your files here or click in this area.</span>
          <small class="upload-hint-908" style="display:block;">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
        </label>
        <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
            <polyline points="13 2 13 9 20 9"></polyline>
          </svg>
          <span class="file-name-908"[title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
          <ng-icon name="tablerX" id="candidate_file_remove_svg_button2" class="file-remove-908" (click)="removeFiles()"></ng-icon>
        </div>
      </div>
    </div>

  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button id="candidate_modal_cancel_button" class="btn btn-default" (click)="close()"> Cancel </button>
        <button id="candidate_modal_ok_button" class="btn  btn-primary" (click)="submitResume()"> OK </button>
      </div>
    </div>
  </div>


</ng-template>


<ng-template #jobsupplytemplate>
  <!-- Dynamic component container for NewJobComponent (circular dependency fix) -->
  <!-- Using div with ID so we can query it from the modal's DOM after modal renders -->
  <div #newJobContainer id="newJobDynamicContainerCandidatesPage"></div>
</ng-template>
<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>
